export default __webpack_public_path__ + "static/media/MoreInfoIcon.bafb1428.svg";